module.exports = __webpack_public_path__ + "static/media/Investor-CHRIS_D_P&A_BRETT_D_ASG_1646441880713.12084664.vtt";